var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 522,
    viewBox: "0 0 512 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.465 156.548L135.464 0.170936L135.391 0.134966L58.0273 44.8312L-0.000222997 78.3562L135.407 156.582L135.465 156.548Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.011 522L376.597 452.317L376.597 452.385L512 374.175L512 78.2325L377.406 0.472506L377.406 3.29939e-05L377.002 0.22507L376.597 3.29231e-05L376.597 0.472506L256.821 69.6825L154.021 10.2825L154.021 166.747L256.821 226.125L376.732 156.848L376.732 295.875L376.664 295.92L376.597 295.875L256.011 365.557L136.213 296.347L136.213 295.942L136.078 295.875L136.078 177.053L0.809976 98.8875L0.809952 373.635L0.00050121 374.107L256.011 522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logo-icon-white.b2bdb788483f1d3e40eb436538c9c7d5.svg";
export { ForwardRef as ReactComponent };